import { WooCommerceAccountBlock } from "@/integrations/wordpress/WooCommerceAccountBlock";
export default function Account() {
  return <section id="account-content" data-nav="light" className="bg-background text-foreground min-h-[60vh] py-12 md:py-16 lg:py-20">
      <div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-16">
        <div className="w-full">
          <WooCommerceAccountBlock />
        </div>
      </div>
    </section>;
}